/*
 * @Autor: haoyi
 * @LastEditors: haoyi
 * @LastEditTime: 2021-11-11 10:49:32
 * @Description:
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import common from './mixin/common.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Toast from '@/plugins/toast/ShowToast'
import 'swiper/dist/css/swiper.css'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
// 配置项
Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: 'dist/error.png',
  // loading: 'dist/loading.gif',
  attempt: 1
})
Vue.config.productionTip = false
Vue.use(Toast)
Vue.mixin(common)
Vue.use(VueAwesomeSwiper)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
